const catbee = require('catbee');
const components = require('catbee-web-components');
const logger = require('./packages/catbee-logger');
const routes = require('./routes');
const uhr = require('catberry-uhr');
const linkSPA = require('catbee-link-spa');
const api = require('./services/api/register');
const handlebars = require('./services/handlebars/browser');
const hbHelpers = require('./services/helpers/handlebars');
const serverTransport = require('./services/transport/server');
const Document = require('./components/layout/document');
const analytics = require('./services/analytics');
const bitrix = require('./services/bitrix');
const gismap = require('./services/gismap');

if (global.ENV.isRelease) {
    require('babel-polyfill');
}

const cat = catbee.create(global.ENV);

/**
 * Секция локализации
 */
require('moment/locale/ru');

/**
 * Плагины для момента
 */
require('moment-range');

/**
 * Секция модулей для jQuery
 */
require('maskedinput');

components.register(cat.locator, Document);
routes.register(cat);
logger.register(cat.locator);
uhr.register(cat.locator);
api.register(cat.locator);
handlebars.register(cat.locator);
hbHelpers.register(cat.locator);
linkSPA.register(cat.locator);
serverTransport.register(cat.locator);
analytics.register(cat.locator);
bitrix.register(cat.locator);
gismap.register(cat.locator);

/**
 * Сервис истории нужен только для разработческого окружения
 */

if (!global.ENV.isRelease) {
    require('./services/history').register(cat.locator);
}


cat.startWhenReady();



// WEBPACK FOOTER //
// ./browser.js